function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var Svg2 = function Svg2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 89.233 120.184"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M-15.657-70.409a25.084 25.084 0 0 1-1.086-7.24c0-9.774 5.43-17.376 16.471-17.376 10.5 0 15.747 6.516 15.747 13.937 0 7.783-3.62 12.67-12.851 18.1l-19.186 11.222C-38.1-39.277-44.255-21.539-44.255 0h89.234v-23.892h-54.3c1.629-3.439 4.525-5.792 7.964-7.964l22.263-13.213c15.023-8.869 23.168-21.358 23.168-36.562 0-21-16.652-38.553-43.621-38.553-28.236 0-43.983 18.824-43.983 39.82 0 3.62.543 8.326 1.086 9.774z",
    "data-name": "Path 32191",
    style: {
      fill: "#fff3ed"
    },
    transform: "translate(44.255 120.184)"
  }));
};
export default Svg2;